import { createApp } from "vue";
import App from "./App.vue";
import * as EvaIcons from "@stefandesu/eva-icons-vue";
import router from "./router";
import BootstrapVue3 from "bootstrap-vue-3";
import Maska from "maska";
import userMixin from "./mixins/userMixin";

import "sweetalert2/dist/sweetalert2.min.css";
import "./assets/scss/custom/plugins/mermaid.min.css";

import store from "./state/store";

import "./assets/scss/app.scss";

store.dispatch("auth/loadUser").then(() => {
  createApp(App)
    .use(store)
    .use(EvaIcons)
    .use(router)
    .use(BootstrapVue3)
    .use(Maska)
    .mixin(userMixin)
    .mount("#app");
});
